<div class="outer-wrapper">
  <div class="form-item-wrapper">
    <!-- <button
      class="btn-reset item item-dropdown"
      ngbTooltip="Section"
      placement="bottom"
      (click)="createSection()">
      <div class="item-icon">
        <img
          class="svg-icon"
          src="/assets/proforms/icon-section.svg"
          alt="Dropdown Icon" />
      </div>
      <div class="item-label visually-hidden">Section</div>
    </button> -->
    <button
      class="btn-reset item item-contentblock"
      ngbTooltip="Content Block"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.CONTENT_BLOCK)">
      <div class="item-icon"><i class="bi bi-card-text"></i></div>
      <div class="item-label visually-hidden">Content Block</div>
    </button>
    <button
      class="btn-reset item item-attachment"
      ngbTooltip="Attachment"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.ATTACHMENT)">
      <div class="item-icon"><i class="bi bi-paperclip"></i></div>
      <div class="item-label visually-hidden">Attachment</div>
    </button>
    <div class="vert-separator"></div>

    <button
      class="btn-reset item item-text"
      ngbTooltip="Text Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.TEXT)">
      <div class="item-icon"><i class="bi bi-input-cursor-text"></i></div>
      <div class="item-label visually-hidden">Text</div>
    </button>
    <button
      class="btn-reset item item-textarea"
      ngbTooltip="Long Text"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.TEXTAREA)">
      <div class="item-icon"><i class="bi bi-text-paragraph"></i></div>
      <div class="item-label visually-hidden">Long Text</div>
    </button>

    <button
      class="btn-reset item item-dropdown"
      ngbTooltip="Dropdown Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.DROPDOWN)">
      <div class="item-icon">
        <img
          class="svg-icon"
          src="/assets/proforms/icon-dropdown.svg"
          alt="Dropdown Icon" />
      </div>
      <div class="item-label visually-hidden">Dropdown</div>
    </button>
    <button
      class="btn-reset item item-radio"
      ngbTooltip="Radio Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.RADIO)">
      <div class="item-icon">
        <img
          class="svg-icon"
          src="/assets/proforms/icon-radio.svg"
          alt="Radio Icon" />
      </div>
      <div class="item-label visually-hidden">Radio</div>
    </button>
    <button
      class="btn-reset item item-checkbox"
      ngbTooltip="Checkbox Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.CHECKBOX)">
      <div class="item-icon"><i class="bi bi-check-square"></i></div>
      <div class="item-label visually-hidden">Checkbox</div>
    </button>
    <button
      class="btn-reset item item-checkboxgrid"
      ngbTooltip="Checkbox Grid Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.CHECKBOX_GRID)">
      <div class="item-icon"><i class="bi bi-ui-checks-grid"></i></div>
      <div class="item-label visually-hidden">Checkbox Grid</div>
    </button>

    <button
      class="btn-reset item item-scale"
      ngbTooltip="Scale Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.SCALE)">
      <div class="item-icon">
        <img
          class="svg-icon"
          src="/assets/proforms/icon-linear-scale.svg"
          alt="Scale Icon" />
      </div>
      <div class="item-label visually-hidden">Scale</div>
    </button>
    <button
      class="btn-reset item item-rubric"
      ngbTooltip="Rubric Question"
      placement="bottom"
      (click)="createItem(ProformFieldTypes.RUBRIC)">
      <div class="item-icon"><i class="bi bi-1-square"></i></div>
      <div class="item-label visually-hidden">Rubric</div>
    </button>
  </div>
</div>
